import Vue from 'vue';

Vue.mixin({
    methods: {
        getPromotionBox(location) {
            return this.$store.state.data.promotions.find((data) => data.slug === location)?.promotion;
        },
    },
});
